module.exports = __webpack_public_path__ + "img/nb_services.6b53fcdd.svg";